import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import {
  Dropdown,
  Popover,
  Whisper,
  WhisperInstance,
  Stack,
  Badge,
  Avatar,
  IconButton,
  Button,
  Modal,
  Message,
  toaster
} from 'rsuite';
import NoticeIcon from '@rsuite/icons/Notice';
import * as images from '../../../src/images/charts';
import globalIP from '@/GlobelIP';
import ugr from '@/UGRoute';
import Port from '../../Port';
import { checkUserDeviceAccess } from '@/utils/checkDeviceLoginToUser';

const ip = globalIP;

const renderAdminSpeaker = ({ onClose, left, top, className }: any, ref) => {
  const handleSelect = eventKey => {
    onClose();
    // console.log(eventKey);
  };
  const userid = localStorage.getItem('id');
  const dataFromSession = localStorage.getItem('fullName');

  const Name = JSON.parse(dataFromSession);
  const handlelogout = async () => {
    await fetch(`${globalIP}/api/user-details/${userid}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          LogT: '0',
          LogoutT: new Date().toISOString()
        }
      })
    })
    localStorage.clear();
    window.location.reload();
  };

  // const [qrValue, setQrValue] = useState(false)
  function setQR() {
    localStorage.setItem('QR', 'true')
  }
  const [open, setOpen] = React.useState(false);
  const handleOpen = value => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const [qrUrl, setQrUrl] = useState('')
  useEffect(() => {
    fetchCompanyDetails();
  }, []);
  const fetchCompanyDetails = async () => {
    try {
      const req = await fetch(`${ip}/api/company-details?populate=*`);
      const res = await req.json();
      console.log(res.data)
      const tradeFairLink = res.data[0].attributes.tradeFairLink
      const withport = `${tradeFairLink}`
      setQrUrl(withport);
    } catch (err) {
      console.error("Error fetching company details:", err);
    }
  };

  return (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item panel style={{ padding: 10, width: 160 }}>
          <p>Signed in as</p>
          <strong>{Name}</strong>
        </Dropdown.Item>
        <Dropdown.Item divider />
        <Link className="link" to={`/${ugr}/changePassword`}>
          <Dropdown.Item>Change Password</Dropdown.Item>
        </Link>
        <Dropdown.Item onClick={handleOpen}>Create Fair QR</Dropdown.Item>
        <Link className="link" to="/">
          <Dropdown.Item onClick={handlelogout}>Sign out</Dropdown.Item>
        </Link>
        {/* <Dropdown.Item
        
        <Dropdown.Item
          icon={<HelpOutlineIcon />}
          href="https://rsuitejs.com"
          target="_blank"
          as="a"
        >
          Help{' '}
        </Dropdown.Item> */}
        <Modal size="sm" open={open} onClose={handleClose}>
          <Modal.Header>
            <Modal.Title>Scan QR Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <QRCode value={qrUrl} size={150} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} appearance="default" color='cyan' active>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </Dropdown.Menu>
    </Popover>
  );
};


// const [open, setOpen] = useState(false);
// const handleOpen = value => {
//   setOpen(true);
// };
// const handleClose = () => setOpen(false);



const renderNoticeSpeaker = ({ onClose, left, top, className }: any, ref) => {
  const notifications = [
    [
      '7 hours ago',
      'The charts of the dashboard have been fully upgraded and are more visually pleasing.'
    ],
    [
      '13 hours ago',
      'The function of virtualizing large lists has been added, and the style of the list can be customized as required.'
    ],
    ['2 days ago', 'Upgraded React 18 and Webpack 5.'],
    [
      '3 days ago',
      'Upgraded React Suite 5 to support TypeScript, which is more concise and efficient.'
    ]
  ];

  return (
    <Popover ref={ref} className={className} style={{ left, top, width: 300 }} title="Last updates">
      {/* <List>
        {notifications.map((item, index) => {
          const [time, content] = item;
          return (
            <List.Item key={index}>
              <Stack spacing={4}>
                <Badge /> <span style={{ color: '#57606a' }}>{time}</span>
              </Stack>

              <p>{content}</p>
            </List.Item>
          );
        })}
      </List> */}

      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <Button onClick={onClose}>More notifications</Button>
      </div>
    </Popover>
  );
};

const Header = ({ expand }) => {
  const trigger = useRef<WhisperInstance>(null);
  let time = new Date().toLocaleTimeString();

  const [ctime, setCtime] = useState(time);

  const UpdateTime = () => {
    time = new Date().toLocaleTimeString();
    setCtime(time);
  };

  setInterval(UpdateTime, 1000);

  const dataFromSessionpass = localStorage.getItem('useid');
  const pass = JSON.parse(dataFromSessionpass);
  const [allFetchedData, setAllFetchedData] = useState([]);
  useEffect(() => {
    fetchAllData();
  }, []);
  const fetchAllData = async () => {
    const response = await fetch(
      `${ip}/api/user-details?populate=*&filters[Username][$eq]=${pass}`
    );
    const json = await response.json();
    setAllFetchedData(json.data);
  };
  ////// Temp Operation////

  const [alltempData, setAlltempData] = useState([]);
  const [alltempid, setAlltempId] = useState([]);
  useEffect(() => {
    fetchtempData();
  }, []);
  const fetchtempData = async () => {
    const response = await fetch(`${ip}/api/temp-products?populate=*`);
    const json = await response.json();
    setAlltempData(json.data);
    setAlltempId(json.data.map(item => item.id));
  };
  const deleteFairProducts = async () => {
    try {
      // Iterate over each fair product ID and delete it
      for (const fairProductId of alltempid) {
        const response = await fetch(`${ip}/api/temp-products/${fairProductId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          // If the deletion is successful, log the result or perform any necessary actions
          // console.log(`Fair product with ID ${fairProductId} deleted successfully.`);
        } else {
          console.error(`Failed to delete fair product with ID ${fairProductId}.`);
        }
      }
      window.location.reload();
    } catch (error) {
      console.error('Error deleting fair products:', error);
    }
  };
  const submitpack = async e => {
    e.preventDefault();
    try {
      for (const temp of alltempData) {
        const productId = temp.attributes.P_Id;
        const updatedProductData = {
          data: {
            ProductCode: temp.attributes.ProductCode,
            ProductId: temp.attributes.AliasCode,
            CategoryCode: temp.attributes.CatetegoryCode,
            ProductTypeCode: temp.attributes.ProductTypeCode,
            SizeUnit: temp.attributes.Unit,
            Length: temp.attributes.len,
            Width: temp.attributes.wid,
            Height: temp.attributes.height,
            Description: temp.attributes.description,
            ProductName: temp.attributes.productname,
            FinishName: temp.attributes.finish,
            ColorName: temp.attributes.color,
            SellingPriceCurrency: temp.attributes.currency,
            SellingPrice: temp.attributes.price,
            NetWeight: temp.attributes.netwgt,
            GrossWeight: temp.attributes.grosswgt,
            Product_Remark: temp.attributes.remark

            // Add other fields you want to update from temp data
          }
        };
        const response = await fetch(`${ip}/api/products/${productId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updatedProductData)
        });

        if (!response.ok) {
          throw new Error('Failed to update product data');
        }

        console.log(`Product with ID ${productId} updated successfully.`);
      }
      deleteFairProducts();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const [companydata, setCompanyData] = useState({});
  useEffect(() => {
    fetchcompData();
  }, []);
  const fetchcompData = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      if (json.data && json.data[0]) {
        setCompanyData(json.data[0]);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  const location = window.location.pathname;
  const navigate = useNavigate();
  const LoginCode = localStorage.getItem('LoginCode');
  const [apiLoginCode, setApiLoginCode] = useState('')
  const getLatestCode = async () => {
    const response = await fetch(`${globalIP}/api/user-details/${localStorage.getItem('id')}`)
    const json = await response.json();
    setApiLoginCode(json.data.attributes.LogT)
  }
  useEffect(() => {
    getLatestCode()
  }, [location])
  useEffect(() => {
    if (apiLoginCode) {
      if (apiLoginCode == LoginCode) {
      } else {
        console.log("not equal")
        localStorage.clear()
        navigate(`/${ugr}/login`);
      }
    }
  }, [apiLoginCode, location])
  const autoCheckDevice = async () => {
    const result = await checkUserDeviceAccess();

    // ❌ If device check fails → Logout user
    if (!result.success) {

      toaster.push(
        <Message type="error" showIcon>{result.message}</Message>,
        { placement: "topCenter" }
      );

      // Clear session / local storage
      localStorage.clear()

      // Redirect to login
      navigate(`/${ugr}/login`);
    }
  };

  useEffect(() => {
    autoCheckDevice();

    // OPTIONAL: Check every 15 seconds
    const interval = setInterval(autoCheckDevice, 15000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Stack
        className="header"
        justifyContent="space-between"
        style={{
          width: '-webkit-fill-available',
          height: '57px',
          zIndex: 10,
          backgroundColor: '#fff',
          borderBottom: '1px solid #e9e9e9',
          position: 'fixed'
        }}
        spacing={8}
      >
        <Stack>
          {expand ? null : (
            <Link to={`/${ugr}/dashboard`}>
              {companydata?.attributes?.Logo?.data?.attributes?.url ? (
                <div style={{ width: '220px' }}>
                  <img
                    className="ug-icon"
                    src={`${ip}${companydata?.attributes?.Logo?.data?.attributes?.url}`}
                    alt="Logo"
                    style={{
                      width: '60%',         // scales automatically to container width
                      height: 'auto',        // keeps original aspect ratio
                      objectFit: 'contain',  // ensures full image visibility
                      maxHeight: '60px'      // prevents oversized logos
                    }}
                  />
                </div>
              ) : (
                <p>Company logo</p>
                // <img className="ug-iconlocal" src={images.UniqG} alt="Default Logo" />
              )}
            </Link>
          )}
        </Stack>
        <Stack style={{ marginRight: '40px' }}>
          {/* {alltempData.length > 1 && (
            <Button onClick={submitpack} style={{ marginRight: '10px' }} active>
              Undo
            </Button>
          )} */}
          {/* <Whisper
            placement="bottomEnd"
            trigger="click"
            ref={trigger}
            speaker={renderNoticeSpeaker}
          >
            <IconButton
              icon={
                // <Badge content={0}>
                <NoticeIcon style={{ fontSize: 20 }} />
                // </Badge>
              }
            />
          </Whisper> */}

          <Whisper
            placement="bottomEnd"
            trigger="click"
            ref={trigger}
            speaker={renderAdminSpeaker}
          >
            <div
              style={{
                padding: "4px 8px",
                background: "#f7f7f8",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                border: "1px solid #e0e0e0",
                marginLeft: 8,
                gap: "6px",
                transition: "0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#ececec")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "#f7f7f8")
              }
            >
              {/* Avatar OR Initial Letter */}
              {allFetchedData[0]?.attributes?.UserImage?.data?.attributes?.url ? (
                <Avatar
                  size="xs"
                  circle
                  src={`${ip}${allFetchedData[0].attributes.UserImage.data.attributes.url}`}
                  alt="user"
                />
              ) : (
                <div
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    background: "#4C6EF5",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "600",
                    fontSize: "12px",
                    textTransform: "uppercase",
                  }}
                >
                  {(allFetchedData[0]?.attributes?.Full_Name || "U")
                    .charAt(0)}
                </div>
              )}

              {/* Username */}
              <span style={{ fontSize: "12px", color: "#333", fontWeight: 500 }}>
                {allFetchedData[0]?.attributes?.Full_Name || "User"}
              </span>

              {/* Arrow */}
              <i
                className="ri-arrow-down-s-line"
                style={{ fontSize: 14, color: "#666" }}
              ></i>
            </div>
          </Whisper>

        </Stack>
      </Stack>


      {/* <Modal size='sm' open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>Modal Title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
          <Button onClick={handleClose} appearance="primary">
            Ok
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Header;
